<script>
import axios from 'axios'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import StatChart from '@components/widget-stat-chart'
import Overview from '@components/overview'
import Member from '@components/member'
import Task from '@components/task'
import Chat from '@components/chat'
import JsonExcel from 'vue-json-excel'
import moment from 'moment'

import {
  revenueAreaChart,
  targetsBarChart,
  salesBarChart,
  //ordersData,
  bottomOrdersData,
} from './data'

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    VuePerfectScrollbar,
    Layout,
    StatChart,
    Overview,
    Member,
    Task,
    Chat,
    JsonExcel,
  },
  data() {
    return {
      revenueAreaChart: revenueAreaChart,
      targetsBarChart: targetsBarChart,
      salesBarChart: salesBarChart,
      //ordersData: ordersData,
      bottomOrdersData: bottomOrdersData,

      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },

      ordersData: [],

      maxHeight: '328px',

      membersInUnion: [],

      agesOne: 0,
      agesTwo: 0,
      agesThree: 0,
      agesFour: 0,

      averageEarning: 0,

      data: [
        {
          name: '16-34',
          value: 1,
        },
        {
          name: '35-54',
          value: 1,
        },
        {
          name: '55-64',
          value: 1,
        },
        {
          name: '65-Above',
          value: 1,
        },
      ],
      chart_json_fields: {
        Title: 'mainTitle',
        Value: 'value',
        'Sub Value': 'subValue',
      },
      chart_json_fields_two: {
        'Product Name': 'name',
        //"Product Value * 1000": "data",
        'Product Value': {
          field: 'data',
          callback: (value) => {
            return `${value}`
          },
        },
      },

      totalMembersValue: 0,
      totalUnionsValue: 0,
      totalResolvedGrievancesValue: 0,
      totalExpectedRevenueValue: 0,
      loadingData: true,

      totalTrainingValue: 0,
      totalContentValue: 0,

      latestMember: {
        name: '-',
        employerId: '-',
      },

      statChart: [
        {
          mainTitle: '- ',
          key:'page.dashboard.chartTitleThree',
          value: this.totalMembersValue,
          subValue: '10.21%',
          chartColor: '#5369f8',
          icon: 'book',
          color: 'primary',
        },
        {
          mainTitle: '-  ',
          key:'page.dashboard.chartTitleFour',
          value: this.totalUnionsValue,
          subValue: '5.05%',
          chartColor: '#f77e53',
          icon: 'bell',
          color: 'success',
        },
        {
          mainTitle: '-   ',
          key:'page.dashboard.chartTitleOne',
          value: this.totalResolvedGrievancesValue,
          subValue: '24.05%',
          chartColor: '#43d39e',
          icon: 'users',
          color: 'info',
        },
        {
          mainTitle: '-    ',
          key:'page.dashboard.chartTitleTwo',
          value: this.averageEarning,
          subValue: '24.05%',
          chartColor: '#43d39e',
          icon: 'dollar-sign',
          color: 'warning',
        },
      ],
      dateConfig: {
        mode: 'range',
      },
      selectedDate: [this.getDatePlusSeven(), this.getCurrentDate()],
      fromDate: this.getDatePlusSeven(),
      toDate: this.getCurrentDate(),
      calendarConfig: {
        wrap: true,
        dateFormat: 'd/m/Y',
        mode: 'range',
        altInput: true,
        altFormat: 'F j, Y',
        time_24hr: false,
      },

      json_fields: {
        'Complete name': 'name',
        City: 'city',
        Telephone: 'phone.mobile',
        'Telephone 2': {
          field: 'phone.landline',
          callback: (value) => {
            return `Landline Phone - ${value}`
          },
        },
      },
    }
  },
  async mounted() {
    await this.initializeData()
  },
  methods: {
    addAge(age) {
      if (age > 16 && age <= 34) this.agesOne += 1
      else if (age > 34 && age <= 54) this.agesTwo += 1
      else if (age > 54 && age <= 64) this.agesThree += 1
      else if (age > 64) this.agesFour += 1
    },
    async initializeData() {
      //console.log('>>>>>>>>>>>>> Inside initializer: '+this.selectedDate)
      var male = 0
      var female = 0
      this.totalUnionsValue = 0
      this.totalMembersValue = 0
      this.totalContentValue = 0
      this.totalTrainingValue = 0
      this.totalResolvedGrievancesValue = 0
      this.loadingData = true

      this.statChart[0].value = '-'
      this.statChart[1].value = '-'
      this.statChart[2].value = '-'
      this.statChart[3].value = '-'

      this.getFromToDate()

      await axios.get('/api/gebi/member/all').then((response) => {
          this.averageEarning = 0
        for (let doc of response.data) {
          this.totalMembersValue += 1
            this.addAge(
              moment().diff(moment(doc.dob, 'DD/MM/YYYY').utc(), 'years')
            )
          if (doc.sex == 'Male') male += 1
          else female += 1
		  
		  this.averageEarning += Number(doc.salary)
        }
		this.averageEarning = Math.round(this.averageEarning / this.totalMembersValue)
      })

      await axios
        .post('/api/gebi/content/all', {
          fromDate: this.fromDate,
          toDate: this.toDate,
        })
        .then((response) => {
          this.totalContentValue = response.data
        })

      await axios
        .post('/api/gebi/training/all', {
          fromDate: this.fromDate,
          toDate: this.toDate,
        })
        .then((response) => {
          //console.log('>>>>>>>>>>>> Data: '+response.data)
          this.totalTrainingValue = response.data
          // for(let doc of response.data)
          // {
          // 	this.totalTrainingValue+=1
          // }
        })

      this.data = [
        {
          name: '16-34',
          value: this.agesOne,
        },
        {
          name: '35-54',
          value: this.agesTwo,
        },
        {
          name: '55-64',
          value: this.agesThree,
        },
        {
          name: '65-Above',
          value: this.agesFour,
        },
      ]

      
      this.statChart[0].value = this.totalTrainingValue
      this.statChart[1].value = this.totalContentValue
      this.statChart[2].value = this.totalMembersValue
      this.statChart[3].value =
        this.numberWithCommas(this.averageEarning) + ' Br.'

      this.loadingData = false
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getDatePlusSeven() {
      var currentDate = new Date().setDate(new Date().getDate() - 30)
      currentDate = new Date(currentDate)
      //console.log('>>>>>>>>> ',currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      return moment(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        )
      ).format('DD/MM/YYYY')
    },
    getCurrentDate() {
      var currentDate = new Date()
      //console.log('>>>>>>>>> ',currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      return moment(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        )
      ).format('DD/MM/YYYY')
    },
    getFromToDate() {
      var index = this.selectedDate.indexOf(' to ')
      var indexTwo = this.selectedDate.indexOf(',')
      if (index >= 0) {
        //valid
        //console.log('>>>>>> I have to')
        this.fromDate = this.selectedDate.substring(0, index)
        this.toDate = this.selectedDate.substring(
          index + 4,
          this.selectedDate.length
        )
      } else if (indexTwo >= 0) {
        //valid
        //console.log('>>>>>> I have comma')
        this.fromDate = this.selectedDate.substring(0, indexTwo)
        this.toDate = this.selectedDate.substring(
          indexTwo + 1,
          this.selectedDate.length
        )
      }
      // console.log(
      // 	'>>>>>> fromDate: ' +
      // 	this.fromDate +
      // 	' | toDate: ' +
      // 	this.toDate
      // )
    },
    getStatusState(item) {
      if (item === 'New') return 'badge-soft-danger'
      else return 'badge-soft-secondary'
    },
    getStageState(item) {
      if (item === 'Member Follow-up') return 'badge-soft-success'
      else if (item === 'No Action') return 'badge-soft-secondary'
      else if (item === 'Letter Sent') return 'badge-soft-primary'
      else return 'badge-soft-dark'
    },
    async downloadClicked() {
      //console.log('>>>>>>>>>>>>>> Download Clicked: Date: ' + this.selectedDate)
      //this.getFromToDate()
      await this.initializeData()
    },
	removeCharacters(text)
	{
		var returningValue=text+''
		//console.log('>>>>>>>>>>>> Data: ', typeof(text))
		returningValue=returningValue.replace(',',' to ')
		returningValue=returningValue.replace('[','')
		returningValue=returningValue.replace(']','')
		return returningValue
	},
  getStyle()
    {
      if(this.$i18n.locale=='am')
      return "font-size-12_am"
      else
      return "font-size-12_en"
    },
    getTitleStyle()
    {
      if(this.$i18n.locale=='am')
      return "titleAm"
      else
      return "titleEn"
    },
    getGreetingTitleStyle()
    {
      if(this.$i18n.locale=='am')
      return "greetingTitleAm"
      else
      return "greetingTitleEn"
    }
  },
}
</script>

<template>
  <Layout>
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 :class="getTitleStyle()">{{ $i18n.t("page.dashboard.title") }}</h4>
      </div>
      <div class="col-sm-8 col-xl-6">
        <form class="form-inline float-sm-right mt-3 mt-sm-0">
          <div class="form-group mb-sm-0 mr-2">
            <flat-pickr
              v-model="selectedDate"
              class="form-control"
              :config="calendarConfig"
              name="date"
            ></flat-pickr>
          </div>
          <div class="btn-group">
            <b-dropdown variant="primary" right>
              <template v-slot:button-content>
                <i class="uil uil-file-alt mr-1"></i>{{ $i18n.t("page.dashboard.download") }}
                <i class="icon">
                  <feather type="chevron-down" class="align-middle"></feather>
                </i>
              </template>
              <b-dropdown-item href="#" class="notify-item">
                <JsonExcel
                  :data="targetsBarChart.series"
                  worksheet="Komari"
                  type="csv"
                  :fields="chart_json_fields_two"
                  name="filename.xls"
                >
                  <feather
                    type="share"
                    class="icon-dual icon-xs mr-2 align-middle"
                  ></feather>

                  <span>{{ $i18n.t("page.dashboard.excel") }}</span>
                </JsonExcel>
              </b-dropdown-item>
              <b-dropdown-item href="#" class="notify-item">
                <feather
                  type="mail"
                  class="icon-dual icon-xs mr-2 align-middle"
                ></feather>
                <span>{{ $i18n.t("page.dashboard.email") }}</span>
              </b-dropdown-item>
              <b-dropdown-item href="#" class="notify-item">
                <feather
                  type="printer"
                  class="icon-dual icon-xs mr-2 align-middle"
                ></feather>
                <span>{{ $i18n.t("page.dashboard.print") }}</span>
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                href="#"
                @click="downloadClicked"
                class="notify-item"
              >
                <feather
                  type="file"
                  class="icon-dual icon-xs mr-2 align-middle"
                ></feather>
                <span>{{ $i18n.t("page.dashboard.regenerate") }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <b-alert :show="loadingData" dismissible fade variant="success">
          <h6 style="color: white" :class="getStyle()">{{ $i18n.t("page.dashboard.updatingDashboard") }}</h6>
        </b-alert>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h2 class="mb-1 mt-0">&nbsp;</h2>
        <h2 :class="getGreetingTitleStyle()"
          >{{ $i18n.t("page.dashboard.hi") }} {{ this.$store.state.auth.currentUser.firstName }}</h2
        >
        <h6 class="text-muted font-weight-normal mt-1 mb-3"
          >{{ $i18n.t("page.dashboard.dataTimeframe") }} {{ removeCharacters(selectedDate) }}</h6
        >
        <h5 class="mb-1 mt-0">&nbsp;</h5>
      </div>
    </div>

    <div class="row">
      <div
        v-for="stat of statChart"
        :key="stat.mainTitle"
        class="col-md-12 col-xl-3"
      >
        <!--StatChart
					:main-title="stat.mainTitle"
					:value="stat.value"
					:sub-value="stat.subValue"
					:chart-color="stat.chartColor"
				/-->
        <div class="card">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span
                  :class="
                    getStyle()
                  "
                  
                  >{{ $i18n.t(stat.key) }}</span
                >
                <h2 class="mb-1">{{ stat.value }}</h2>
              </div>
              <div class="align-self-center">
                <span>
                  <feather
                    :type="`${stat.icon}`"
                    :class="`icon-lg align-middle icon-dual-${stat.color}`"
                  ></feather>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <span
              :class="getStyle()"
              >{{ $i18n.t("page.dashboard.graphTitleThree") }}</span
            >
            <div class="chart">
              <pie-chart
                :data="data"
                pie-style="donut"
                label-position="center"
                legend
                theme="walden"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <span
              :class="getStyle()"
              >{{ $i18n.t("page.dashboard.idDescription") }}</span
            >
            <div class="text-center mt-3">
              <qrcode
                :value="this.$store.state.auth.currentUser.id"
                :size="140"
              />

              <h5 class="mt-2 mb-0">{{
                this.$store.state.auth.currentUser.firstName +
                ' ' +
                this.$store.state.auth.currentUser.fatherName
              }}</h5>

              <h6 class="text-muted font-weight-normal mt-1 mb-1">{{
                this.$store.state.auth.currentUser.position
              }}</h6>
              <h6 class="font-weight-normal mt-1 mb-4">{{
                this.$store.state.auth.currentUser.employerId
              }}</h6>
            </div>
          </div>
        </div>
      </div>
      

      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <span
              :class="getStyle()"
              >{{ $i18n.t("page.dashboard.profileAtGlance") }}</span
            >
            <div class="mt-3 pt-2">
              <div class="table-responsive">
                <table class="table table-borderless mb-0 text-muted">
                  <tbody>
                    <tr>
                      <th scope="row" :class="getStyle()">{{ $i18n.t("page.dashboard.dob") }}</th>
                      <td>{{ this.$store.state.auth.currentUser.dob }}</td>
                    </tr>
                    <tr>
                      <th scope="row" :class="getStyle()">{{ $i18n.t("page.dashboard.phone") }}</th>
                      <td>{{
                        this.$store.state.auth.currentUser.contactNumber
                      }}</td>
                    </tr>
                    <tr>
                      <th scope="row" :class="getStyle()">{{ $i18n.t("page.dashboard.email") }}</th>
                      <td>{{ this.$store.state.auth.currentUser.email }}</td>
                    </tr>
                    <tr>
                      <th scope="row" :class="getStyle()">{{ $i18n.t("page.dashboard.address") }}</th>
                      <td>
                        {{ $i18n.t("page.dashboard.houseNumber") }}:
                        {{ this.$store.state.auth.currentUser.houseNumber }}
                        {{ $i18n.t("page.dashboard.woreda") }}:
                        {{ this.$store.state.auth.currentUser.woreda }} 
                        {{ $i18n.t("page.dashboard.zoneSubCity") }}:
                        {{ this.$store.state.auth.currentUser.zoneSubcity }}
                        {{ $i18n.t("page.dashboard.city") }}: {{ this.$store.state.auth.currentUser.city }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!--div class="mt-3 pt-2 border-top">
              <h4 class="mb-3 font-size-15">Skills</h4>
              <label class="badge badge-soft-primary">UI design</label>
              <label class="badge badge-soft-primary ml-1">UX</label>
              <label class="badge badge-soft-primary ml-1">Sketch</label>
              <label class="badge badge-soft-primary ml-1">Photoshop</label>
              <label class="badge badge-soft-primary ml-1">Frontend</label>
            </div-->
          </div>
        </div>
      </div>
    </div>

    <!--div class="row">
			<div v-if="ordersData.length>0" class="col-xl-12">
				<div class="card">
					<div class="card-body">
						<a
							href="javascript: void(0);"
							class="btn btn-primary btn-sm float-right"
						>
							<i class="uil uil-export ml-1"></i> Export
						</a>
						<h5 class="card-title mt-0 mb-0 header-title">Latest Events</h5>
						<div class="table-responsive mt-4 mb-0">
							<b-table-simple class="table table-hover table-nowrap mb-0" 
								style="cursor: pointer;">
								<b-thead class="thead-white">
									<b-tr>
										<b-th>#</b-th>
										<b-th>Title</b-th>
										<b-th>Description</b-th>
										<b-th>Venue</b-th>
										<b-th>Date</b-th>
									</b-tr>
								</b-thead>
								<b-tbody>
									<b-tr v-for="order in ordersData" :key="order.id">
										<b-td>{{ order.id }}</b-td>
										<b-td>{{ order.name }}</b-td>
										<b-td>{{ order.subject }}</b-td>
										<b-td>{{ order.submitted }}</b-td>
										<b-td>
											<span
												class="badge"
												:class="getStatusState(order.status)"
												>{{ order.status }}</span
											>
										</b-td>
									</b-tr>
								</b-tbody>
							</b-table-simple>
						</div>
					</div>
				</div>
			</div>

			<div v-if="ordersData.length>0" class="col-xl-12">
				<div class="card">
					<div class="card-body">
						<a
							href="javascript: void(0);"
							class="btn btn-primary btn-sm float-right"
						>
							<i class="uil uil-export ml-1"></i> Export
						</a>
						<h5 class="card-title mt-0 mb-0 header-title">Latest Trainings</h5>
						<div class="table-responsive mt-4 mb-0">
							<b-table-simple class="table table-hover table-nowrap mb-0" 
								style="cursor: pointer;">
								<b-thead class="thead-white">
									<b-tr>
										<b-th>#</b-th>
										<b-th>Title</b-th>
										<b-th>Description</b-th>
										<b-th>Date Added</b-th>
										<b-th>Attached Files</b-th>
									</b-tr>
								</b-thead>
								<b-tbody>
									<b-tr v-for="order in ordersData" :key="order.id">
										<b-td>{{ order.id }}</b-td>
										<b-td>{{ order.name }}</b-td>
										<b-td>{{ order.subject }}</b-td>
										<b-td>{{ order.submitted }}</b-td>
										<b-td>
											<span
												class="badge"
												:class="getStatusState(order.status)"
												>{{ order.status }}</span
											>
										</b-td>
									</b-tr>
								</b-tbody>
							</b-table-simple>
						</div>
					</div>
				</div>
			</div>

		</div-->
  </Layout>
</template>
<style scoped>
.chart {
  width: 100%;
  height: 300px;
}
.font-size-12_en {
    font-size: 12px !important;
    text-transform: uppercase !important;
    font-weight: 700 !important;
}
.font-size-12_am {
    font-size: 15px !important;
    text-transform: uppercase !important;
    font-weight: 500 !important;
}
.titleAm{
  font-size: 22px !important;
  font-weight: 400 !important;
}
.titleEn{
  font-size: 19px !important;
  font-weight: 600 !important;
}

.greetingTitleAm{
  font-size: 1.75rem !important;
  font-weight: 500 !important;
}
.greetingTtitleEn{
  font-size: 1.75rem !important;
  font-weight: 600 !important;
}
</style>